import { createClient } from '../../client/createClient'
import { createSubscan } from '../../explorer'
import type { Chain } from '../types'

type CreateAstarChainParameters = {
  explorerApiKey?: string
  explorerProxyUrl?: string
  rpcEndpoints?: string[]
}

export const createPolkadotChain = ({
  explorerApiKey,
  explorerProxyUrl,
  rpcEndpoints = polkadotWebsocketRpcUrls,
}: CreateAstarChainParameters): Chain => {
  return {
    /** {@link https://polkadot.subscan.io/parachain_list?status=parachain} */
    id: 0,
    /** {@link https://github.com/paritytech/ss58-registry/blob/main/ss58-registry.json} */
    ss58Prefix: 0,
    network: 'polkadot',
    name: 'Polkadot (Relay Chain)',
    blockTimeSeconds: 6,
    nativeToken: {
      name: 'Polkadot',
      symbol: 'DOT',
      decimals: 10,
      currency: {
        symbol: 'DOT',
        type: 'CryptoCurrency',
        id: 'polkadot',
        name: 'Polkadot',
        updatedAt: 0,
      },
    },
    client: createClient(rpcEndpoints),
    explorer: createSubscan({
      name: 'Subscan',
      baseUrl: 'https://polkadot.subscan.io',
      networkName: 'polkadot',
      apiKey: explorerApiKey,
      proxyUrl: explorerProxyUrl,
    }),
    rpcEndpoints,
    assetType: 'assets',
    // relay chain に asset はない
    assetMap: new Map(),
  }
}

export const polkadotWebsocketRpcUrls = [
  'wss://polkadot-public-rpc.blockops.network/ws',
  'wss://polkadot-rpc.dwellir.com',
  'wss://polkadot-rpc-tn.dwellir.com',
  'wss://rpc.ibp.network/polkadot',
  'wss://polkadot.dotters.network',
  'wss://rpc-polkadot.luckyfriday.io',
  'wss://polkadot.api.onfinality.io/public-ws',
  'wss://polkadot.public.curie.radiumblock.co/ws',
  'wss://rockx-dot.w3node.com/polka-public-dot/ws',
  'wss://dot-rpc.stakeworld.io',
  'wss://polkadot.rpc.subquery.network/public/ws',
]
